import { loadStripe } from "@stripe/stripe-js";

import { formatPrice } from "utils";
import { config } from "api";

// "+ tax" (not "+ HST"): the rate/name depends on the billing location's
// province chosen at checkout (BC/AB pay GST, not HST).
export const getPrice = ({price, discount = 0, countryCode}: {price: number, countryCode: string, discount?: number}) => (
    `${formatPrice(Math.round(price * (100 - discount) / 100))} ${countryCode === 'CA' ? '+ tax' : ''}`
)

export const getStripe = async (country: string | number) => {
    const countryKey = Number(country) === 1 || country === 'US' ? 'US' : 'CA';
    const pubKey = config.stripe[countryKey].pubKey
    return await loadStripe(pubKey);
}
